// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"auth_loginPage__tX6fp","loginbox":"auth_loginbox__2sb2G","facebookButton":"auth_facebookButton__3Hbdi"};